import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserDetail } from 'lms-api';
import { UserCourseDataService } from 'lms-api';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TrainingLicenseService } from '../_services/training-license.service';

@Component({
  selector: 'app-license-update',
  templateUrl: './license-update.component.html',
  styleUrls: ['./license-update.component.scss']
})
export class LicenseUpdateComponent implements OnInit {
  public userDetails$: Observable<UserDetail> = this.ucdService.User;
  public Licenses$ = this.licenseService.Get();
  public licenseSaved: boolean = false;

  public states = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];

  public licenseForm = new UntypedFormGroup({
    state: new UntypedFormControl('', Validators.required),
    number: new UntypedFormControl('', Validators.required),
  })


  constructor(public licenseService: TrainingLicenseService, private ucdService: UserCourseDataService) { }

  ngOnInit(): void {
  }

  AddLicense() {
    let licenseFormValue = this.licenseForm.value;
    this.licenseService.AddLicense(licenseFormValue.state, licenseFormValue.number).subscribe(result => {
      let licenseArray = [];
      licenseArray.push(result);
      this.Licenses$ = of(licenseArray);
      this.licenseSaved = true;
    })
  }
}
